module.exports = __webpack_public_path__ + "img/gioco.91bcb1c2.png";